import { settleApiCall } from '../../../api/utils';
import { createFieldToEntityMap } from '../../../utils/common';
import { getModifiersIds } from '../../../utils/modifiers';
export const getModifiers = async _ref => {
  let {
    modifiersClient,
    modifierGroups,
    populationLevel
  } = _ref;
  const shouldPopulateModifiers = populationLevel == null ? void 0 : populationLevel.modifiers;
  if (shouldPopulateModifiers) {
    const modifierIds = getModifiersIds(modifierGroups);
    const modifiersApiResponse = await settleApiCall(() => modifiersClient.getBulk({
      ids: modifierIds
    }));
    if (modifiersApiResponse.hasError) {
      return modifiersApiResponse;
    }
    const {
      data: modifiers
    } = modifiersApiResponse.data;
    const modifiersMap = createFieldToEntityMap(modifiers, 'id');
    return {
      data: modifiers,
      idsToEntityMap: modifiersMap,
      hasError: false
    };
  }
  return {
    data: [],
    hasError: false
  };
};
//# sourceMappingURL=getModifiers.js.map